import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import Text from '../Text/Text';
import checkBoxIcon from './assets/checkbox-white-tick.png';
var StyledInput = styled.input.withConfig({
  displayName: "Checkbox__StyledInput",
  componentId: "ngak0-0"
})(["font-size:", ";display:block;box-sizing:border-box;opacity:0;position:absolute;left:0px;width:30px;height:30px;margin:0;border:1px solid ", ";+ span{margin-right:5px;width:30px;height:30px;background-color:", ";border:1px solid ", ";float:left;}:checked + span{background:url(", ") no-repeat center;background-color:", ";background-size:contain;}:focus + span{border-color:", ";border-width:3px;}:focus + span{border-color:", ";border-width:3px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize('sm');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color('grey_for_forms');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color('white');
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color('grey_for_forms');
}, checkBoxIcon, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color('purple');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color('grey_for_forms');
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color('grey_for_forms');
});
var Label = styled.label.withConfig({
  displayName: "Checkbox__Label",
  componentId: "ngak0-1"
})(["display:flex;align-items:center;margin-bottom:8px;"]);

var Checkbox = function Checkbox(_ref8) {
  var label = _ref8.label,
      value = _ref8.value,
      rest = _objectWithoutProperties(_ref8, ["label", "value"]);

  return React.createElement(Label, null, React.createElement(StyledInput, Object.assign({
    type: "checkbox"
  }, rest, {
    value: value
  })), React.createElement("span", null), React.createElement(Text, {
    weight: "bold"
  }, label));
};

export default Checkbox;